import React, { useEffect, useState } from 'react';
import { Dropdown } from '@yme/atoms/dropdown';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { addNoneOption } from './helpers';
export const DependentDropdown = ({ items, id, inputPlaceholder, labelText, blurHandler, onChange, isRequired, ChildPickListDictionary, }) => {
    const [primarySelected, setPrimarySelected] = useState('');
    const [childSelected, setChildSelected] = useState('');
    useEffect(() => {
        if (primarySelected && !isRequired && !childSelected) {
            onChange?.(primarySelected);
        }
    }, [isRequired, onChange, primarySelected, childSelected]);
    const handlePrimaryChange = (value) => {
        setPrimarySelected(value);
        setChildSelected('');
    };
    const handleChildChange = (value) => {
        setChildSelected(value);
        const sendValue = value === 'none' ? primarySelected : value;
        onChange?.(sendValue);
    };
    const filteredChildOptions = primarySelected
        ? addNoneOption(ChildPickListDictionary, primarySelected, isRequired)
        : [];
    return (React.createElement(FlexWrapper, { isFullWidth: true, flexDirection: "column", gap: "10px" },
        React.createElement(Dropdown, { id: id, items: items, activeItem: primarySelected, onChange: handlePrimaryChange, inputPlaceholder: inputPlaceholder, labelText: labelText, blurHandler: blurHandler, isRequired: isRequired }),
        primarySelected && (React.createElement(Dropdown, { id: `child_dropdown_${id}`, items: filteredChildOptions, activeItem: childSelected, onChange: handleChildChange, labelText: ChildPickListDictionary[primarySelected]?.label, inputPlaceholder: ChildPickListDictionary[primarySelected]?.placeholder, isRequired: isRequired }))));
};
